import { useDispatch, useSelector } from "react-redux"


import { useEffect, useState } from "react"

import img_bell from '../../../assets/images/notifiche.svg'

import { selectTranslations } from "../../../services/i18n/i18nSlice"
import { TitleH1 } from "../../../components/TitleH1"
import { Text } from "../../../components/Text"
import SecureImage from "../../../components/_partials/SecuredImage"
import { API_URL } from "../../../config/constants"
import { TitleH2 } from "../../../components/TitleH2"
import { Button } from "../../../components/Button"
import { fetchGetNotifications } from "../../../features/Notification/notificationApi"
import Anchor from "../../../components/Anchor"

export default function FolderNotification (params) {

    const t = useSelector(selectTranslations)

    const [communicationsData, setCommunicationsData] = useState(null)

    const loadCommunications = async () => {
        let response = await fetchGetNotifications({
           folder_id: params?.folder_id,
           type: 'banner'
        })
        if(response.success){
            console.log('folder',response);
            
            setCommunicationsData(response?.data?.communications[0])
        }
    }

    useEffect(()=>{
        if(params?.folder_id)
            loadCommunications()
    },[params?.folder_id])

    return (
        <section className="notification_banner">
            {
                communicationsData &&
                    <div className="communication_banner">
                        <div className="icon">
                            {
                                communicationsData?.icon_image_url ?
                                    <SecureImage imageUrl={`${API_URL}${communicationsData?.icon_image_url}`} height="20px" width="20px" className="w-100"/>
                                : <img src={img_bell} className="w-100" />
                            }
                        </div>
                        <div className="content">
                            <TitleH2>{communicationsData?.title}</TitleH2>
                            <Text>{communicationsData.text}</Text>
                            {
                                communicationsData?.cta &&
                                <Anchor href={communicationsData?.cta?.url} target="_blank">
                                    {communicationsData?.cta?.title}
                                </Anchor>
                            }
                        </div>
                    </div>
            }
        </section>
        
    )
}